import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { IResponseUploadDocToComment } from "./types";

export const getAllDocsByComment = async (commentId: string): Promise<IResponseUploadDocToComment> => {
  try {
    const response = await apiClientSource.get(`/task-service/api/comments/comments/${commentId}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener los documentos del comentario");
    throw error;
  }
}